<template>
	<form class="login-form edit-form" action="javascript:void(0)" method="post" v-if="setPsw==0">
		<div class="login-logo"></div>
		<div class="login-title">设置密码</div>
		<input class="newPsw" type="password" name="newPsw" v-model="newPsw" value="" placeholder="输入新密码" />
		<div class="tipCommon"></div>
		<input class="confirmPsw" type="password" name="confirmPsw" v-model="confirmPsw" value="" placeholder="确认新密码" />
		<div class="tipCommon"></div>
		<input type="submit" class="submit-btn" name="login-submit" id="loginSubmit" value="完成" @click="setPsdFun" />
	</form>
</template>

<script>
	export default {
		name: 'setPassword',
		data() {
			return {
				newPsw: "",
				confirmPsw: "",
				uid: ""
			}
		},
		created: function() {
			let _this = this
			this.Hub.$on('eventBus', function(val) {
				console.log("中转站" + val) //hello
				// this.msg2 = val;
				_this.uid = val
			})
		},
		mounted: function() {

		},
		props: {
			setPsw: {
				default: ""
			}
		},
		watch: {},
		methods: {
			setPsdFun: function() {
				if(!this.newPsw) {
					this.common.newTip($(".newPsw"), "请输入新密码")
					return;
				}
				if(!this.confirmPsw) {
					this.common.newTip($(".confirmPsw"), "请确认新密码")
					return;
				}
				if(this.newPsw != this.confirmPsw) {
					this.common.newTip($(".confirmPsw"), "确认密码与新密码不同")
					return;
				}
				if(!this.newPsw.match(/^[a-z,A-Z][\w]{5,19}$/i)) {
					this.common.newTip($(".newPsw"), "密码请输入6-20个包含字母和数字，首字母必须是字母")
					return false;
				}
				let data = {};
				data.id = this.uid;
				data.password = this.newPsw;
				let _this = this;
				this.common.post("user/loginSetPassword", (ret) => {
					_this.layer.closeAll('loading');
					if(ret.id != null) {
						localStorage.setItem('user', JSON.stringify(ret))
						location.href = "/"
					}
				}, data, true, ()=> {
					let index = _this.layer.load(1, {
						shade: [0.1, '#fff'] //0.1透明度的白色背景
					});
				})
			}
		}

	}
</script>

<style scoped="">
	@import url("../../../static/css/login.css");
</style>


// WEBPACK FOOTER //
// src/components/loginPage/setPassword.vue